export default "__VITE_ASSET__CgasnWnN__"